"use client";

import type { ProductCard, ProductDetails, Variant } from "@raumagarn/formatters";
import { AddToCartButton } from "~/components/ui/AddToCartButton";
import { YarnPreview } from "~/components/ui/YarnPDPContainer/YarnPreview";
import { useOutsideClick } from "~/lib/hooks/useOutsideClick";
import styles from "./YarnPDPContainer.module.css";

interface Props {
	yarn?: Variant;
	product: ProductDetails | ProductCard;
	open: boolean;
	onOpenChange: (open: boolean) => void;
}
export const YarnAddToCart = ({ yarn, open, onOpenChange, product }: Props) => {
	const ref = useOutsideClick(() => {
		onOpenChange(false);
	});

	const size = yarn?.items?.[0];

	return (
		<>
			{open && <span className={styles.previewBackdrop} />}
			<div ref={ref} className={styles.addToCartWrapper}>
				{yarn && <YarnPreview open={open} onOpenChange={onOpenChange} yarn={yarn} />}
				<AddToCartButton
					product={product}
					quantityPicker
					selectedSize={size as NonNullable<ProductDetails["variants"]>[number]["size"]}
				/>
			</div>
		</>
	);
};
